import React from 'react';
import { compose, branch, renderNothing } from 'recompose';
import { TransLink } from '../Common/Translations';
import config, { currentCountryCode } from '../../config';
import { withStoreDetail } from '../Common/Providers/WithStoreDetail';
import { willHideOnMuslimPro, isPrepaidStore } from '../Common/Store/Store';

const Card = (props) => {
  const {
    currency,
    product = {},
  } = props;
  return (
    <div className="card h-100">
      <TransLink url={product.url}>
        <img className="img-fluid lazyload w-100" width="293" height="224" data-src={`${config.s3BucketUrl}${product.img}`} alt={product.name}/>
      </TransLink>
      <div className="p-3">
        <h5 className="ProximaNova-Bold text-gray-darken-1 mb-2">{product.name}</h5>
        <div className="small text-gray">
          {product.priceBefore &&
          <div>From <del>{currency} {product.priceBefore}</del></div>}
          {product.priceAfter &&
          <strong className="ProximaNova-Bold text-secondary">{currency} {product.priceAfter}</strong>}
        </div>
      </div>
    </div>
  );
};

const Deals = (props) => {
  const {
    store,
    t,
  } = props;
  const deals = t('landing_page.homepagedeals_deals', '');
  const products = deals ? deals.split('\n') : [];
  return (
    <div id="deals" className="my-5">
      <div className="container">
        <div className="row my-3">
          <div className="col-12 text-center">
            <h2 className="ProximaNova-Bold landing-h4 mb-2">{t('landing_page.homepagedeals_title', 'Buy Now, Create Later')}</h2>
            <p className="mb-0 text-gray">{t('landing_page.homepagedeals_lead', 'Secure the best deals and up to 3 months to create your project with our prepaid vouchers.')}</p>
          </div>
        </div>
        <div className="row px-2 text-center">
          {products.map((value, index) => {
            const product = { name: '', img: '', url: '', priceBefore: '', priceAfter: '' };
            const productDetails = value.split('|');
            productDetails.forEach((elem, i) => {
              product[Object.keys(product)[i]] = elem;
            });
            if (product.name || product.img) {
              return (
                <div key={`deals-${index}`} className="col-6 col-lg-3 px-1 px-sm-2 mb-2 mb-sm-3">
                  <Card product={product} currency={store.currency.code}/>
                </div>
              );
            }
            return '';
          })}
        </div>
        <div className="text-center my-3">
            <TransLink url='/promotions/prepaid'>{t('landing_page.homepagedeals_link_text', 'View all deals >')}</TransLink>
        </div>
      </div>
    </div>
  );
};

const isNotPrepaidCountry = () => !isPrepaidStore({ code: config.storeCode });

const enhance = compose(
  withStoreDetail,
  branch(
    isNotPrepaidCountry,
    renderNothing,
  ),
  willHideOnMuslimPro,
);

export default enhance(Deals);
export const undecorated = Deals;



// WEBPACK FOOTER //
// ./src/LandingPage/Deals.js